<template>
  <div class="subs">
    <div class="box has-background-light">
      <div class="columns" style="margin-bottom:0;">
        <div class="column">סה"כ: {{ total }} ({{ active }} פעילים)</div>
      </div>
      <sub-filter></sub-filter>
    </div>

    <notification v-if="$store.state.notificationShow"></notification>
    <div class="table-scroll">
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <th>שם</th>
          <th>שם משתמש</th>
          <th>סוג חשבון</th>
          <th>תאריך החיוב הבא</th>
          <th>ביטול טוקן</th>
          <th>סטטוס חשבון</th>
          <th>חיוב ידני</th>
        </thead>
        <tbody>
          <sub-item v-for="sub in subs" :key="sub.id" :sub="sub"></sub-item>
        </tbody>
      </table>
      <div class="has-text-centered" v-if="showLoadMore">
        <button class="button is-success" @click="addResults">טען עוד</button>
      </div>
    </div>
  </div>
</template>

<script>
import SubItem from "./SubItem";
import SubFilter from "./SubFilter";
import Notification from "./Notification";

export default {
  props: {
    subs: Array
  },
  components: {
    SubItem,
    SubFilter,
    Notification
  },

  methods: {
    addResults() {
      this.$store.dispatch("addResults");
    }
  },

  computed: {
    showLoadMore() {
      if (this.$store.state.subList.length >= this.$store.state.total) {
        return false;
      }
      return true;
    },
    total() {
      return this.$store.state.total;
    },

    active() {
      return this.$store.state.totalActive;
    }
  }
};
</script>

<style lang="scss">
.subs,
.ref-list,
.cupons {
  .table-scroll {
    max-height: 75vh;
    overflow-y: scroll;
  }

  .table.no-margin {
    margin-bottom: 0;
  }

  .table {
    thead {
      background-color: cadetblue;
    }
    th {
      text-align: center;
    }
    td {
      text-align: center;
    }
  }
}
</style>
